import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ml-4 mr-4" }

import { computed } from "vue";
import { useStore } from "vuex";
import TwLabel from "../TwLabel.vue";
import TwCheckbox from "../TwCheckbox.vue";
import TwTextarea from "../TwTextarea.vue";


export default /*#__PURE__*/_defineComponent({
  __name: '8.AreasOfConcernInSkin',
  setup(__props) {

const store = useStore();

const areasOfConcernInSkinOther = computed({
  get: () => store.state.form.areas_of_concern_in_skin_other,
  set: (value) => store.dispatch("updateAreasOfConcernInSkinOther", value),
});

const selectedConcerns = computed(() => {
  return Object.keys(store.state.form).filter((key) => store.state.form[key]);
});

const updateConcerns = (newValues: string[]) => {
  newValues.forEach((value) => {
    switch (value) {
      case "areas_of_concern_in_skin_breakouts_acne":
        store.dispatch("updateAreasOfConcernInSkinBreakoutsAcne", true);
        break;
      case "areas_of_concern_in_skin_blackheads_whiteheads":
        store.dispatch("updateAreasOfConcernInSkinBlackheadsWhiteheads", true);
        break;
      case "areas_of_concern_in_skin_uneven_skin_tone":
        store.dispatch("updateAreasOfConcernInSkinUnevenSkinTone", true);
        break;
      case "areas_of_concern_in_skin_sun_damage":
        store.dispatch("updateAreasOfConcernInSkinSunDamage", true);
        break;
      case "areas_of_concern_in_skin_excessive_oil_shine":
        store.dispatch("updateAreasOfConcernInSkinExcessiveOilShine", true);
        break;
      case "areas_of_concern_in_skin_wrinkles_fine_lines":
        store.dispatch("updateAreasOfConcernInSkinWrinklesFineLines", true);
        break;
      case "areas_of_concern_in_skin_dull_dry_skin":
        store.dispatch("updateAreasOfConcernInSkinDullDrySkin", true);
        break;
      case "areas_of_concern_in_skin_rosacea":
        store.dispatch("updateAreasOfConcernInSkinRosacea", true);
        break;
      case "areas_of_concern_in_skin_broken_capillaries":
        store.dispatch("updateAreasOfConcernInSkinBrokenCapillaries", true);
        break;
      case "areas_of_concern_in_skin_redness_ruddiness":
        store.dispatch("updateAreasOfConcernInSkinRednessRuddiness", true);
        break;
      case "areas_of_concern_in_skin_dehydration":
        store.dispatch("updateAreasOfConcernInSkinDehydration", true);
        break;
      case "areas_of_concern_in_skin_spots":
        store.dispatch("updateAreasOfConcernInSkinSpots", true);
        break;
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TwLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("areas_of_concern_in_skin")), 1)
      ]),
      _: 1
    }),
    _createVNode(TwCheckbox, {
      options: [
      {
        label: _ctx.$t('areas_of_concern_in_skin_breakouts_acne'),
        value: 'areas_of_concern_in_skin_breakouts_acne',
      },
      {
        label: _ctx.$t('areas_of_concern_in_skin_blackheads_whiteheads'),
        value: 'areas_of_concern_in_skin_blackheads_whiteheads',
      },
      {
        label: _ctx.$t('areas_of_concern_in_skin_uneven_skin_tone'),
        value: 'areas_of_concern_in_skin_uneven_skin_tone',
      },
      {
        label: _ctx.$t('areas_of_concern_in_skin_sun_damage'),
        value: 'areas_of_concern_in_skin_sun_damage',
      },
      {
        label: _ctx.$t('areas_of_concern_in_skin_excessive_oil_shine'),
        value: 'areas_of_concern_in_skin_excessive_oil_shine',
      },
      {
        label: _ctx.$t('areas_of_concern_in_skin_wrinkles_fine_lines'),
        value: 'areas_of_concern_in_skin_wrinkles_fine_lines',
      },
      {
        label: _ctx.$t('areas_of_concern_in_skin_dull_dry_skin'),
        value: 'areas_of_concern_in_skin_dull_dry_skin',
      },
      {
        label: _ctx.$t('areas_of_concern_in_skin_rosacea'),
        value: 'areas_of_concern_in_skin_rosacea',
      },
      {
        label: _ctx.$t('areas_of_concern_in_skin_broken_capillaries'),
        value: 'areas_of_concern_in_skin_broken_capillaries',
      },
      {
        label: _ctx.$t('areas_of_concern_in_skin_redness_ruddiness'),
        value: 'areas_of_concern_in_skin_redness_ruddiness',
      },
      {
        label: _ctx.$t('areas_of_concern_in_skin_dehydration'),
        value: 'areas_of_concern_in_skin_dehydration',
      },
      {
        label: _ctx.$t('areas_of_concern_in_skin_spots'),
        value: 'areas_of_concern_in_skin_spots',
      },
    ],
      modelValue: selectedConcerns.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((selectedConcerns).value = $event)),
        updateConcerns
      ]
    }, null, 8, ["options", "modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TwLabel, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("areas_of_concern_in_skin_other")), 1)
        ]),
        _: 1
      }),
      _createVNode(TwTextarea, {
        modelValue: areasOfConcernInSkinOther.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((areasOfConcernInSkinOther).value = $event)),
        rows: 1,
        id: "areasOfConcernInSkinOther"
      }, null, 8, ["modelValue"])
    ])
  ], 64))
}
}

})